exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".builder-modal .sweet-modal.is-alert{background-color:transparent;width:1000px;-webkit-box-shadow:unset;box-shadow:unset}.builder-modal .sweet-modal.is-alert .sweet-content{padding:0}.builder-modal .sweet-modal .sweet-box-actions .sweet-action-close{color:#fff}.builder-modal .sweet-modal .sweet-box-actions .sweet-action-close:hover{background-color:transparent}.builder-modal .sweet-modal .sweet-box-actions{top:6px}", ""]);

// exports
